import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { Params, RouterLink } from '@angular/router';

@Component({
  imports: [
    CommonModule,
    RouterLink,
  ],
  selector: 'app-button',
  styleUrl: './button.component.scss',
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  action = output<HTMLElement>();
  ariaLabel = input('');
  disabled = input(false);
  href = input('');
  icon = input<string | undefined>(undefined);
  iconPosition = input<'left' | 'right'>('left');
  innerId = input.required<string>();
  internalLink = computed(() => this.href().startsWith('/'));
  label = input('');
  loading = input(false);
  preventDefault = input(false);
  queryParams = input<Params>({});
  rel = input('');
  stopPropagation = input(false);
  styleClass = input('primary');
  target = input('_self');

  protected triggerAction(event: Event): void {
    if (this.disabled() || this.loading()) {
      event?.preventDefault();
      event?.stopPropagation();
      return;
    }
    if (this.preventDefault()) {
      event?.preventDefault();
    }
    if (this.stopPropagation()) {
      event?.stopPropagation();
    }
    this.action.emit(event.currentTarget as HTMLElement);
  }
}
